import { useState, useEffect } from 'react'
import { get } from 'aws-amplify/api'

import { RuntimeHistory } from 'types/RuntimeHistory'
import { getCachedAuthSession } from 'services/authSessionCache'

const useServerlessRth = (
  dealerId: number,
  deviceId: string,
  startTime: string,
  endTime: string,
  timeZone: string,
  refreshTimestamp: number
) => {
  const [rthData, setRthData] = useState<RuntimeHistory | null>(null)
  const [isRTHDataLoaded, setIsRTHDataLoaded] = useState(false)

  useEffect(() => {
    (async () => {
      setIsRTHDataLoaded(false)
      const session = await getCachedAuthSession()

      try {
        const res = await get({
          apiName: 'dwaApi',
          path: `/rth/${deviceId}?startDate=${startTime}&endDate=${endTime}&timezone=${timeZone}`,
          options: {
            headers: { 'Authorization': session?.tokens?.idToken?.toString() || '' }
          }
        }).response

        const rth = await res.body.json()

        setRthData(rth as unknown as RuntimeHistory)
      } catch (_error) { // eslint-disable-line @typescript-eslint/no-unused-vars
      } finally {
        setIsRTHDataLoaded(true)
      }
    })()
  }, [deviceId, dealerId, startTime, endTime, timeZone, refreshTimestamp])

  return { rthData, isRTHDataLoaded }
}

export default useServerlessRth
